import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Check, X } from "lucide-react";
import { toast } from "sonner";

const BENEFITS = [
  "Catas ilimitadas",
  "Comparador y gráficos radar sin límite",
  "Exportación de fichas en PDF",
  "Historial y búsqueda avanzada",
];

export default function UpsellDialog({ open, onOpenChange, count = 10, limit = 10 }) {
  const subscribe = () => {
    toast.success("La suscripción anual estará disponible muy pronto. ¡Gracias por tu interés!");
    onOpenChange(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 overflow-hidden rounded-2xl border-0" data-testid="upsell-dialog">
        <DialogTitle className="sr-only">Límite de catas alcanzado</DialogTitle>
        <div className="p-7 text-center" style={{ background: "#5A1E2C" }}>
          <div className="mx-auto w-14 h-14 rounded-2xl flex items-center justify-center mb-4" style={{ background: "rgba(200,169,106,0.18)" }}>
            <Crown className="w-7 h-7" style={{ color: "#C8A96A" }} />
          </div>
          <h3 className="font-serif text-2xl text-white">Has alcanzado tu límite gratuito</h3>
          <p className="text-white/75 text-sm mt-2">
            Registraste {count} de {limit} catas del plan gratuito. Suscríbete al <span style={{ color: "#C8A96A" }}>plan anual</span> para catas ilimitadas.
          </p>
        </div>
        <div className="p-7 bg-white">
          <ul className="space-y-3 mb-6">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-center gap-3 text-sm text-neutral-700">
                <span className="w-5 h-5 rounded-full flex items-center justify-center shrink-0" style={{ background: "#5A1E2C" }}>
                  <Check className="w-3 h-3 text-white" />
                </span>
                {b}
              </li>
            ))}
          </ul>
          <Button data-testid="subscribe-annual-btn" onClick={subscribe}
            className="w-full h-12 rounded-full font-semibold text-base" style={{ background: "#C8A96A", color: "#5A1E2C" }}>
            <Crown className="w-4 h-4 mr-2" /> Suscribirme al plan anual
          </Button>
          <button data-testid="upsell-dismiss-btn" onClick={() => onOpenChange(false)}
            className="w-full mt-3 text-sm text-neutral-500 hover:text-neutral-700 transition-colors flex items-center justify-center gap-1">
            <X className="w-3.5 h-3.5" /> Ahora no
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
